// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___tfypN","thumb_root":"style-module__thumb_root___Sd50W","thumb":"style-module__thumb___sYJ1e","seconds_root":"style-module__seconds_root___VQihM"};
    if(module.hot) {
      // 1697460475718
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  